import { AnyAction } from 'redux';
import { AppContext, AppContextActions, EmployeeContext, ExternalLinkState, NavigationContext, SystemContext, UserContext } from '../models/app-context-model';

const InitialState: AppContext = {
	userContext: null,
	externalLinkState: {
		renderModal: false,
		linkUrl: '',
		linkInnerHtml: '',
	},
	employeeContext: null,
	systemContext: null,
	userNavigationContext: null,
};

export const appContextApiReducer = (state = InitialState, action: AnyAction): AppContext => {

	switch (action.type) {
		case AppContextActions.SET_USER_CONTEXT:
			return {
				...state,
				userContext: action.payload,
			};
		case AppContextActions.SET_EXTERNAL_LINK_STATE:
			return {
				...state,
				externalLinkState: action.payload,
			};
		case AppContextActions.SET_EMPLOYEE_CONTEXT:
			return {
				...state,
				employeeContext: action.payload,
			};
		case AppContextActions.SET_NAVIGATION_CONTEXT:
			return {
				...state,
				userNavigationContext: action.payload,
			};

		case AppContextActions.SET_SYSTEM_CONTEXT:
			return {
				...state,
				systemContext: action.payload,
			};
		default: return state;
	}
};


export const setUserContext = (context: UserContext): AnyAction => ({
	type: AppContextActions.SET_USER_CONTEXT,
	payload: context,
});

export const setExternalLinkState = (linkState: ExternalLinkState): AnyAction => {
	return {
		type: AppContextActions.SET_EXTERNAL_LINK_STATE,
		payload: linkState,
	};
};

export const setEmployeeContext = (employeeContext: EmployeeContext): AnyAction => {
	return {
		type: AppContextActions.SET_EMPLOYEE_CONTEXT,
		payload: employeeContext,
	};
};

export const setNavigationContext = (navigationContext: NavigationContext): AnyAction => {
	return {
		type: AppContextActions.SET_NAVIGATION_CONTEXT,
		payload: navigationContext,
	};
};

export const setSystemContext = (systemContext: SystemContext): AnyAction => {
	return {
		type: AppContextActions.SET_SYSTEM_CONTEXT,
		payload: systemContext,
	};
};